import { animateScroll, scroller } from "react-scroll";

const SCROLL_OPTIONS = {
  duration: 800,
  delay: 0,
  smooth: "easeInOutQuart"
};

export function scrollTo(name) {
  scroller.scrollTo(name, SCROLL_OPTIONS);
}

export function scrollToTop() {
  animateScroll.scrollToTop(SCROLL_OPTIONS);
}

export default {
  scrollTo,
  scrollToTop
};
